import React, { useEffect, useState } from "react";
import { Label } from "../../../../../components/formInputs";
import {
    AutoComplete,
    DatePicker,
    ErrorCommon,
    NumberTextField,
    SelectField,
    TextField,
    TextFieldCommon,
} from "../../../../../components/formikFormInputs";
import {
    defaultOfferTypes,
    defaultStrategies,
    livingBenefitsAllianz,
    livingBenefitsNationalLife,
    policyStatus,
    PolicyStatusEnum,
} from "../../../../../constants";
import { Button, Grid, Typography, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../reducers";
import { useActions } from "../../../../../actions";
import * as ClientActions from "../../../../../actions/client";
import * as AccountActions from "../../../../../actions/account";
import * as Actions from "../../../../../actions/account";
import PolicyStatus from "../modals/PolicyStatus";
import InputAdornment from "@material-ui/core/InputAdornment";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { checkProofExpiry, getGroupNumber } from "../../../../../utils/commonUtils";
import BirthDate from "../../../Enrollment/EnrollmentHome/basicInfo/ProfileFormFields/BirthDate";
import PersonalDetailFieldObj from "../../../Enrollment/EnrollmentHome/basicInfo/PersonalDetailFieldObj";
import moment from "moment";
import {
    getMonths,
    getNextYears,
    lastDayOfMonth,
} from "../../../Enrollment/EnrollmentHome/basicInfo/PersonalDetailUtils";
import CommonFieldFunction from "../../../Enrollment/EnrollmentHome/basicInfo/CommonFieldFunction";
import * as CarrierActions from "../../../../../actions/carrier";
import BlotFieldShowHide from "../../../../../components/formikFormInputs/BlotFieldShowHide";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import { useFormikContext } from "formik";
import GreenCardAndVisaExpiry from "../../../Enrollment/EnrollmentHome/basicInfo/GreenCardAndVisaExpiry";
import { nonUsInformationFields } from "../../../Enrollment/allianzAppHome/basicInfo/PersonalDetailFieldObj";
import {
    PhysicianAndMedicalDetailsStyle
} from "../../../Enrollment/EnrollmentHome/EnrollmentApplication/MedicalAndFinancial/medicalStyle";
import { createStyles, makeStyles } from "@material-ui/styles";
import EditIcon from "@material-ui/icons/Edit";
import {isNfIulCase} from "../../../../../utils/commonFunc";
import { stateDropDownArr } from "../../../Enrollment/allianzAppHome/basicInfo/PersonalDetailUtils";
import { isAllianzApp } from "../../../Enrollment/EnrollmentHome/EnrollmentApplication/Utilities";
import { GenericDialogProps } from "../../../../../components/dialog";
import GenericDialog from "../../../../../components/dialog/GenericDialog";
import LabelWithIcon from "../../../../../components/client/Proposal/LabelWithIcon";


const applicationType: object[] = [
    {
        key: "ILIA",
        value: "ILIA",
        name: "ILIA",
    }, {
        key: "NIW",
        value: "NIW",
        name: "NIW",
    }, {
        key: "PAPER",
        value: "PAPER",
        name: "PAPER",
    },
];
interface caseDetailsProps {
    values: any,
    handleChange: Function,
    errors: any,
    touched: any,
    clientPolicyId: string,
    caseDetails: any,
    caseProcessorList: any,
    caseManagerList: any,
    fetchCaseDetail: Function,
    ssnFlag: boolean,
    disabled: boolean,
    setFieldValue?: Function,
    handleBlur?: Function,
    setActionItem: Function,
    setMinAge: Function,
    minAge: number,
    policyStatusDisabled: boolean
    refreshDetails?: Function,
}

const useStyles = makeStyles(() =>
        createStyles(
                {
                    padding12: {
                        padding: "12px"
                    },
                },
        ),
);
const CaseDetails = (props: caseDetailsProps) => {
    const accountActions = useActions(Actions);
    const carrierActions = useActions(CarrierActions);
    const { getOfferByCarrierId } = useActions(ClientActions);
    const { getAgentImoStrategies, getLivingBenefitsList } = useActions(AccountActions);
    const detail: any = useSelector((state: RootState) => state.clientAccount);
    const clientPolicy = detail && detail.client && detail.client.clientPolicies.length > 0 && detail.client.clientPolicies[0] || {};

    const classes = useStyles();
    const {
        values,
        handleChange,
        errors,
        touched,
        clientPolicyId,
        caseDetails,
        caseProcessorList,
        caseManagerList,
        fetchCaseDetail,
        ssnFlag,
        disabled = false,
        setFieldValue,
        handleBlur,
        setActionItem,
        setMinAge,
        minAge,
        policyStatusDisabled,
        refreshDetails
    } = props;
    let { user: { role, participant } } = useSelector((state: RootState) => state.auth);
    let formValues = values;
    let userData = useSelector((state: RootState) => state.profile);
    let user = detail && detail.client || userData;
    const clientSigned = clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.clientSigned ? 1 : 0;
    const [offerTypes, setOfferTypes] = useState<any>(defaultOfferTypes);
    const [strategyDropDownOptions, setStrategyDropDownOptions] = useState<any>(defaultStrategies);
    const carrierOfferTypes: any = useSelector((state: RootState) => state.carrierOfferTypes);
    const [policyStatusPopup, setPolicyStatusPopup] = React.useState(false);
    const [livingBenefits, setLivingBenefits] = React.useState<object[]>([]);

    const [carrierId, setCarrierId] = React.useState<number | null>(null);
    const [nationalLifeId, setNationalLifeId] = React.useState<number | null>(null);
    const [isNationalLife, setIsNationalLife] = React.useState<boolean>(false);
    const [isAllianzLife, setIsAllianzLife] = React.useState<boolean>(false);
    const [allianzId, setAllianzId] = React.useState<number | null>(null);
    const [strategySlug, setStrategySlug] = React.useState("");
    const [labelsActive, setLabelsActive] = React.useState<any[]>([]);
    const [actualHealthRatingTitle, setActualHealthRatingTitle] = React.useState([]);
    // 0 -> locked, 1 -> pop-open to confirm need to unlock or not , 2 confirm to be edit
    const [isEditIssueAge, setEditIssueAge] = React.useState(0);
    const [days, setDays] = React.useState([
        {
            id: "",
            key: "",
            name: "",
        },
    ]);
    // const [isIssueAgeDisabled, setIsIssueAgeDisabled] = React.useState<boolean>(false);
    const clientCarrier = caseDetails && caseDetails.carrier;
    const getAllianzCarrierDetails = async () => {
        const allianzData = await accountActions.getAllianzDetails();
        setAllianzId(allianzData.allianzLife.id);
    };
    const getNationalLifeCarrierDetails = async () => {
        const nationalLifeDate = await accountActions.getNationalLifeDetails();
        if (nationalLifeDate && nationalLifeDate.nationalLife) {
            setNationalLifeId(nationalLifeDate.nationalLife.id);
        }
    };

    useEffect(() => {
        getAllianzCarrierDetails();
        getNationalLifeCarrierDetails();
    }, []);
    useEffect(() => {
        if (isNationalLife) {
            setMinAge(18); //for National Life Carrier MIN AGE is 18;
        }
    }, [isNationalLife]);

    useEffect(() => {
        if (isAllianzLife) {
            setMinAge(18); //for National Life Carrier MIN AGE is 18;
        }
    }, [isAllianzLife]);

    useEffect(() => {
        if (nationalLifeId && carrierId && nationalLifeId === carrierId && strategySlug === "kaizen") {
            setIsNationalLife(true);
        }
    }, [nationalLifeId, carrierId]);

    useEffect(() => {
        if (allianzId && carrierId && allianzId === carrierId && strategySlug === "kaizen") { //if Allianz Life and strategy is Kaizen
            setIsAllianzLife(true);
        }
    }, [allianzId, carrierId]);

    useEffect(() => {
        setOfferTypes(defaultOfferTypes);
        if (carrierOfferTypes.length > 0) {
            let carrierOfferTypesobj = carrierOfferTypes.map((offer) => {
                return {
                    id: offer.value,
                    name: offer.name,
                    value: offer.value,
                };
            });
            setOfferTypes(carrierOfferTypesobj);
        }
    }, [strategyDropDownOptions, carrierOfferTypes]);

    useEffect(() => {
        let ClientCarrierId = clientPolicy && clientPolicy.carrier && clientPolicy.carrier.id;
        if (ClientCarrierId > 0) {
            getAgentStrategies(ClientCarrierId);
            getOfferByCarrierId(ClientCarrierId, false);
            // if(caseDetails && caseDetails.carriersDetails){
            //     if(caseDetails.carriersDetails && caseDetails.carriersDetails.allianzLife && caseDetails.carriersDetails.allianzLife.value === caseDetails.carrierId){
            //         setIsIssueAgeDisabled(true);
            //     } else if(caseDetails.carriersDetails && caseDetails.carriersDetails.nationalLife && caseDetails.carriersDetails.nationalLife.value === caseDetails.carrierId){
            //         setIsIssueAgeDisabled(true);
            //     } else {
            //         setIsIssueAgeDisabled(false);
            //     }
            // }
        }
        if (clientPolicy.strategy && clientPolicy.strategy.slug) {
            setStrategySlug(clientPolicy.strategy.slug);
        }
        if (clientPolicy && clientPolicy.carrierId) {
            setCarrierId(clientPolicy && clientPolicy.carrierId);
        }



    }, [detail]);

    useEffect(() => {
        if (carrierId) {
            carrierActions.getCarrierActualHealthTitle(carrierId).then((res) => {
                const actualHealthArr = res && res.length && res.map((item, index) => {
                    return {
                        key: item.title,
                        value: item.title,
                        name: item.title,
                    };
                }) || [];
                setActualHealthRatingTitle(actualHealthArr);
            });
        }
    }, [carrierId]);

    useEffect(() => {
        if (caseDetails && caseDetails.carrierId) {
            if (caseDetails && caseDetails.carriersDetails) {
                if (caseDetails.carriersDetails && caseDetails.carriersDetails.allianzLife && caseDetails.carriersDetails.allianzLife.value === caseDetails.carrierId) {
                    livingBenefitsDropDown(livingBenefitsAllianz);
                } else if (caseDetails.carriersDetails && caseDetails.carriersDetails.nationalLife && caseDetails.carriersDetails.nationalLife.value === caseDetails.carrierId) {
                    livingBenefitsDropDown(livingBenefitsNationalLife);
                } else {
                    livingBenefitsDropDown(livingBenefitsNationalLife);
                }
            }
        }
        getDays();
        carrierDropDown();
    }, [caseDetails.carriersDetails && caseDetails.carriersDetails.allianzLife && caseDetails.carriersDetails.allianzLife.value,
        caseDetails.carriersDetails && caseDetails.carriersDetails.nationalLife && caseDetails.carriersDetails.nationalLife.value,
        caseDetails.carrierId]);

    const livingBenefitsDropDown = async (benefits: any) => {
        let livingBenefitsArr: object[] = [];

        const result = await getLivingBenefitsList();
        if (result && result.length > 0) {
            result.forEach((item: any) => {
                if (benefits.find(p => p.name === item.name)) {
                    const pushTo: object = {
                        key: item.id,
                        value: item.id,
                        name: item.name,
                    };
                    livingBenefitsArr.push(pushTo);
                }
            });
        }
        setLivingBenefits(livingBenefitsArr);
    };

    const getAgentStrategies = async (carrierId: number) => {
        const [agentId, imoId]: [number, number] = [clientPolicy.agent && clientPolicy.agent.id || 0, clientPolicy.imo && clientPolicy.imo.id || 0];
        let agentImoStrategies = await getAgentImoStrategies({
            agentId,
            carrierId,
            imoId,
            type: "INDIVIDUAL",
        });

        strategyDropDown(agentImoStrategies);
    };

    const strategyDropDown = strategies => {
        let strategyListArr: object[] = [];

        if (strategies && strategies.data && strategies.data.length > 0) {
            strategies.data.forEach((cs: any, subIdx: number) => {
                const pushTo = {
                    key: (cs && cs.strategyId) || 0,
                    value: (cs && cs.strategyId) || 0,
                    name: cs["strategies.name"] || "",
                };
                strategyListArr.push(pushTo);
            });
        }
        setStrategyDropDownOptions(strategyListArr);
        return strategyListArr;
    };

    const carrierDropDown = () => {
        let carrierListArr: object[] = [];
        const pushTo = {
            key: clientCarrier && clientCarrier.id,
            value: clientCarrier && clientCarrier.id,
            name: clientCarrier && clientCarrier.carrierName,
        };
        carrierListArr.push(pushTo);
        return carrierListArr;
    };

    const handleClickOpen = () => {
        setPolicyStatusPopup(true);
    };

    const handleClose = () => {
        refreshDetails && refreshDetails()
        setPolicyStatusPopup(false);
    };
    const purposeDisabled = (formValues['policyStatus'] === PolicyStatusEnum.InForce);

    const fieldObj = [
        {
            name: "policyNumber",
            label: <Label label={"Policy Number"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "fullWidthcustomFields",
            disabled,
        },
        {
            id: "policyStatus",
            name: "policyStatus",
            label: <Label label={"Current Policy Status"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "fullWidthcustomFields",
            inputProps: {
                style: { cursor: "pointer" },
            },
            InputProps: {
                endAdornment: <InputAdornment
                        className="margin0 dollerIcon cursor" position="start"
                ><ArrowDropDownIcon /></InputAdornment>,
                readOnly: true,
                style: { cursor: "pointer" },
            },
            onClick: () => {
                if (policyStatusDisabled) {
                    return true;
                }
                setPolicyStatusPopup(true);
            },
            disabled:policyStatusDisabled,
        },
        {
            id: "caseProcessorId",
            name: "caseProcessorId",
            label: <Label label={"Case Processor"} />,
            isRequired: false,
            component: SelectField,
            className: "fullWidthcustomFields",
            variant: "outlined",
            options: caseProcessorList,
            disabled
        },
        {
            id: "caseManagerId",
            name: "caseManagerId",
            label: <Label label={"Case Manager"} />,
            isRequired: false,
            component: SelectField,
            className: "fullWidthcustomFields",
            variant: "outlined",
            options: caseManagerList,
            disabled
        },
        {
            id: "purpose",
            name: "purpose",
            label: <Label label={"Application Type"} />,
            isRequired: true,
            component: SelectField,
            className: "fullWidthcustomFields",
            variant: "outlined",
            options: applicationType,
            // onSelectChange: (val: number) => {
            // },
            disabled: purposeDisabled,
        },
        {
            name: "employeeSSN",
            id: "employeeSSN",
            label: <Label label={values && values.usCitizen === 1 ? "Social Security Number" : "ITIN"} />,
            component: BlotFieldShowHide,
            formValues:formValues,
            filedType: "string",
            variant: "outlined",
            disabled:true,
            className: "fullWidthcustomFields",
            formatChars: {
                "9": "[0-9]",
            },
        },
        // {
        //     name: "dob",
        //     label: <Label label={"DOB"}/>,
        //     isRequired: true,
        //     placeholder: "DOB",
        //     id: "dob",
        //     variant: "outlined",
        //     disableFuture: true,
        //     component: DatePicker,
        //     className: "fullWidthcustomFields",
        //     disabled
        // },

        {
            id: "healthRating",
            name: "healthRating",
            label: <Label label={"Applied Health Rating"} />,
            isRequired: true,
            component: SelectField,
            className: "fullWidthcustomFields",
            variant: "outlined",
            options: actualHealthRatingTitle,
            onSelectChange: (val: number) => {
            },
            disabled,
        },
        {
            name: "actualHealthRating",
            label: <Label label={"Actual Health Rating"} />,
            isRequired: true,
            component: SelectField,
            variant: "outlined",
            className: "fullWidthcustomFields",
            options: actualHealthRatingTitle,
            onSelectChange: (val: number) => {
            },
            disabled,
        },
        {
            name: "actualHealthRatingOther",
            label: <Label label={"Actual Health Rating Other"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "fullWidthcustomFields",
            disabled,
        },
        {
            name: "strategyName",
            label: <Label label={"ilia Product Type"} />,
            id: "strategyName",
            isRequired: true,
            placeholder: "ilia Product Type",
            component: TextField,
            disabled: true,
            className: "fullWidthcustomFields",
        },
        {
            label: <Label label={"Carrier"} />,
            id: "carrierId",
            name: "carrierId",
            placeholder: "Select Carrier",
            component: SelectField,
            options: carrierDropDown(),
            onSelectChange: (val: number | string) => {
                getOfferByCarrierId(val, false);
                getAgentStrategies(val as number);
            },
            disabled: true,
            className: "fullWidthcustomFields",
        },
        {
            name: "productName",
            label: <Label label={"Carrier Product Type"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "fullWidthcustomFields",
            disabled,
        },
        {
            label: <Label label={"Offer Type"} />,
            id: "offerType",
            name: "offerType",
            placeholder: "Select Offer Type",
            component: SelectField,
            options: offerTypes,
            onSelectChange: (val: number | string) => {

            },
            disabled: true,
            className: "fullWidthcustomFields",
        },
        {
            name: "agent",
            label: <Label label={"Agent"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            disabled: true,
            className: "fullWidthcustomFields",
        },
        {
            name: "imo",
            label: <Label label={"IMO"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "fullWidthcustomFields",
            disabled: true,
        },
        {
            name: "salesRegion",
            label: <Label label={"Sales Region"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "fullWidthcustomFields",
            disabled: true,
        },
        {
            name: "issueDate",
            label: <Label label={"Issue Date"} />,
            isRequired: true,
            placeholder: "Issue Date",
            id: "issueDate",
            component: DatePicker,
            disabled: true,
            className: "fullWidthcustomFields",
        },
        {
            id: "trancheStarted",
            name: "trancheStarted",
            label: <Label label={"Tranche Started"} />,
            placeholder: "Tranche Started",
            component: TextField,
            filedType: "number",
            variant: "outlined",
            className: "fullWidthcustomFields",
            disabled: true
        },
        {
            id: "trancheClosed",
            name: "trancheClosed",
            label: <Label label={"Tranche Closed"} />,
            placeholder: "Tranche Closed",
            component: TextField,
            filedType: "number",
            variant: "outlined",
            disabled: true,
            className: "fullWidthcustomFields",
        },
        {
            id: "livingBenefit",
            name: "livingBenefit",
            label: <Label label={"Living Benefits"} />,
            isRequired: true,
            component: SelectField,
            className: "fullWidthcustomFields",
            variant: "outlined",
            options: livingBenefits,
            multiple: true,
            value:values.livingBenefit,
            onSelectChange: (val: number) => {
            },
            disabled,
        },
    ];

    const dialogProps: GenericDialogProps = {
        actions: (
                <>
                    <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                // handleRemoveFocus();
                                setEditIssueAge(0);
                            }}
                            className="btnContainedRed floatRight mr20"
                    >
                        Cancel
                    </Button>
                    <Button
                            type="submit"
                            variant="contained"
                            onClick={() => {
                                // setIsChanged(true);
                                setEditIssueAge(2);
                            }}
                            color="primary"
                            className="floatRight mr20"
                    >
                        Edit
                    </Button>
                </>
        ),
        "aria-labelledby": "pop-up",
        content: ("The displayed value was generated from an automated source. Editing will override the value for this field only. The source will remain unchanged. Continue?"),
        onClose: () => {
            // handleRemoveFocus();
            setEditIssueAge(0);
        },
        open: isEditIssueAge === 1,
        title: "Edit Issue Age",
    };

    const issueAge = [
        {
            id: "issueAge",
            name: "issueAge",
            label: <LabelWithIcon label="Issue Age" isChanged={isEditIssueAge == 2} required={true} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "fullWidthcustomFields",
            onClick: () => isEditIssueAge == 0 && setEditIssueAge(1),
            // validate: (value)=> {
            //     if (value === null || value === undefined || value === "") {
            //         return
            //     }
            //     const num = typeof value === 'number'
            //             ? value : Number(String(value).trim());
            //     if (Number.isNaN(num)) {
            //         return "Age must be between 18 and 65";
            //     }
            //     if (num < 18 || num > 65) {
            //         return "Age must be between 18 and 65";
            //     }
            //     return;
            // },
            disabled: false
        }
    ];
    const setAnticipatedAge = (date, setValue, formValues) => {
        const age = moment().diff(date, "years");
        setValue("age", age);
    };
    const getDays = (year: number = 2020, month: number = 1) => {
        let lastDay: number = lastDayOfMonth(year, month);
        let day: any = [];
        for (let index = 1; index <= lastDay; index++) {
            day.push({
                id: index,
                key: index,
                name: index,
            });
        }
        setDays(day);
        return day;
    };
    const fieldObj4 = PersonalDetailFieldObj.fieldObj4(false, setAnticipatedAge, getDays, days);

    if (clientPolicy && clientPolicy.tranche) {
        fieldObj.push({
            name: "groupNumber",
            label: <Label label={"Group Number"} />,
            id: "groupNumber",
            isRequired: false,
            placeholder: "Group Number",
            component: TextField,
            disabled: true,
            className: "fullWidthcustomFields",
        });
        const groupNumber = getGroupNumber(`${clientPolicy && clientPolicy.tranche && clientPolicy.tranche.trancheNumber}`);
        formValues = Object.assign(values, { groupNumber });
    }
    fieldObj.push({
        name: "anniversaryDate",
        label: <Label label={"Anniversary Date"} />,
        isRequired: true,
        placeholder: "Anniversary Date",
        id: "anniversaryDate",
        component: DatePicker,
        disabled,
        className: "fullWidthcustomFields",
    });
    fieldObj.push({
        name: "annualPremium",
        label: <Label label={"Annual Premium"} />,
        isRequired: true,
        placeholder: "Annual Premium",
        id: "annualPremium",
        component: NumberTextField,
        disabled: false,
        className: "fullWidthcustomFields",
    });
    fieldObj.push({
        name: "issuedContribution",
        label: <Label label={"Issued Contribution"} />,
        isRequired: true,
        placeholder: "Issued Contribution",
        id: "issuedContribution",
        component: NumberTextField,
        disabled: false,
        className: "fullWidthcustomFields",
    });
    const getFieldFocusValue = (name: string) => {
        let findResult: any = labelsActive.find((label: any) => {
            return label.name === name;
        });
        if (!findResult) {
            return false;
        }

        return findResult.value;
    };
    const CommonField = (
            filedProps,
            action: {
                handleChange?: Function,
                handleBlur: Function,
                values?: any,
                errors?: any,
                touched?: any,
                setFieldValue: any
            },
    ) => {
        return (
                <CommonFieldFunction
                        filedProps={filedProps}
                        action={action}
                        conditionalRequired={false}
                        role={role}
                        setActionItem={setActionItem}
                        client={detail.client}
                        labelsActive={labelsActive}
                        setLabelsActive={setLabelsActive}
                        clientSigned={clientSigned}
                        getFieldFocusValue={getFieldFocusValue}

                />);
    };

    return (
            <React.Fragment>
                <GenericDialog {...dialogProps} />
                <Grid container spacing={3}>
                    {fieldObj.map((field, index) => {
                        if (formValues["actualHealthRating"] !== "Other" && field.name === "actualHealthRatingOther") {
                            return null;
                        }
                        return (
                                <Grid
                                        item xs={12} md={6} lg={6} xl={4} key={index} className="mb15"
                                >
                                    <TextFieldCommon
                                            {...field} values={formValues} onChange={handleChange}
                                    />
                                    <ErrorCommon
                                            errors={errors} name={field.name} touched={touched}
                                    />

                                </Grid>
                        );
                    })
                }
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        {
                        <BirthDate
                            fieldObj4={fieldObj4}
                            minAge={minAge}
                            CommonField={CommonField}
                            values={values}
                            errors={errors}
                            touched={touched}
                            setFieldValue={setFieldValue}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                        />
                        }

                            {clientPolicy && clientPolicy.tranche &&  clientPolicy.tranche.id && issueAge.map((field, index) => {
                                return (
                                        <Grid item xs={12} md={3} lg={2} xl={2}
                                              key={index} className="mb15">
                                            <TextFieldCommon
                                                    {...field}
                                                    values={formValues}
                                                    onChange={handleChange}
                                            />
                                            <ErrorCommon errors={errors} name={field.name}
                                                         touched={touched}/>
                                        </Grid>
                                );
                            })
                            }
                    </Grid>
                </Grid>
                    <Grid container spacing={1}>
                        <DocumentFields />
                    </Grid>
                    <Grid container className={classes.padding12} spacing={3}>
                        <UsCitizenRelatingFields clientPolicy={clientPolicy} />
                    </Grid>
                </Grid>
                {
                    policyStatusPopup &&
                    <PolicyStatus
                            policyStatusPopup={policyStatusPopup}
                            handleClickOpen={handleClickOpen}
                            handleClose={handleClose}
                            clientPolicyId={clientPolicyId}
                            caseDetails={caseDetails}
                            fetchCaseDetail={fetchCaseDetail}
                            ssnFlag={ssnFlag}
                            setPolicyStatusPopup={setPolicyStatusPopup}
                    />
                }
            </React.Fragment>
    );

};
export default CaseDetails;


const UsCitizenRelatingFields = (props: { clientPolicy: any}) =>{
    const { values, setFieldValue, handleChange, handleBlur, errors, touched } = useFormikContext<any>();
    const { clientPolicy } = props
    const accountActions = useActions(Actions);
    const carrierActions = useActions(CarrierActions);
    const classes = PhysicianAndMedicalDetailsStyle();
    const clientSigned = clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.clientSigned ? 1 : 0;
    const isNfIul = clientPolicy && clientPolicy.strategy && isNfIulCase((clientPolicy.strategy.id) as number, clientPolicy.strategy.slug);

    return <>
        <Grid item xs={12}>
            <span className="hLine"/>
            <Typography variant="h6" className="fontBold w100 mb20">Citizenship Details</Typography>
        </Grid>
        <Grid item xs={12} md={12}>
            <Typography variant="caption" className="floatLeft">
                <Label label={"Are you a U.S. citizen?"}
                       required={false} />
            </Typography>
            <ToggleButtonGroup id={"usCitizen"} className="toggleButtonGroup mb30" size="large" exclusive
                               value={values["usCitizen"]}
                               onChange={async () => {
                                   setFieldValue && setFieldValue("usCitizen", !values["usCitizen"]);
                                   setFieldValue("immigrationStatus", undefined)
                                   setFieldValue("immigrationStatusOther", undefined);
                                   setFieldValue("typeOfVisaHeld", "");
                                   setFieldValue("typeOfVisaPlanHeld", "");
                                   setFieldValue("greenCardExpiryMonth", undefined);
                                   setFieldValue("greenCardExpiryYear", undefined);
                                   setFieldValue("visaExpiryMonth", undefined);
                                   setFieldValue("visaExpiryYear", undefined);
                                   setFieldValue("greenCardNo", "");
                                   // if (values["usCitizen"]) {
                                   //     setNonUSPopUp(true);
                                   // }
                                   let payload: any = {};
                                   payload["usCitizen"] = !values["usCitizen"];
                                   await accountActions.updateUserBasicDetails(payload, (clientPolicy && clientPolicy.id) || 0, "");
                               }}>
                <ToggleButton value={true} disabled={!!clientSigned}
                              className={values["usCitizen"] ? "active" : ""}>
                    Yes
                </ToggleButton>
                <ToggleButton value={false} disabled={!!clientSigned}
                              className={values["usCitizen"] ? "" : "active"}>
                    No
                </ToggleButton>
            </ToggleButtonGroup>
        </Grid>

        {!values["usCitizen"] && nonUsInformationFields(true, isNfIul).map((field: any, index) => {
            return (
                    <Grid item xs={12} md={12} key={index + field["name"]}>
                        <Typography variant="body1"
                                    className="floatLeft mt20 mb0">
                            {field.label}
                        </Typography>
                        <Typography variant="caption"
                                    className="floatLeft mt20 mb10 w100 textRed">
                            {field.subLabel}
                        </Typography>

                        <RadioGroup
                                id={field.name}
                                className="mb0 checkGroup checkGroupEnrollment"
                                name={field.name}

                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    const prevValue = values[field.name]; // previous immigration status

                                    setFieldValue(field.name, selectedValue);
                                    // always reset unrelated fields
                                    setFieldValue("immigrationStatusOther", "");
                                    setFieldValue("typeOfVisaHeld", "");
                                    setFieldValue("typeOfVisaPlanHeld", "");
                                    setFieldValue("greenCardExpiryMonth", "");
                                    setFieldValue("greenCardExpiryYear", "");
                                    setFieldValue("visaExpiryMonth", "");
                                    setFieldValue("visaExpiryYear", "");
                                    setFieldValue("greenCardNo", "");

                                }}
                                value={values[field.name]}
                        >

                            <Grid container spacing={2}>
                                {field.options.map((option: any, idx: number) => (
                                        <Grid item xs={12}>
                                            <Grid container spacing={2} key={idx + option.name}>
                                                <Grid item xs={12} md={8} className={classes.radioGroup}>
                                                    <div className="floatLeft w100">
                                                        <FormControlLabel
                                                                className="mb0"
                                                                disabled={!!clientSigned}
                                                                value={option.value}
                                                                control={
                                                                    <Radio
                                                                            className="mb15 f18"
                                                                            color="primary" />}
                                                                label={option.label} />
                                                    </div>
                                                    {option.textField &&
                                                            <Grid container>
                                                                <Grid item
                                                                      xs={12}
                                                                      md={option.value === "1" || option.value === "OTHER" ? 12 : 6}
                                                                      className="">
                                                                    {/*<Grid item xs={12} md={6} xl={6} key={index}>*/}
                                                                        <TextFieldCommon
                                                                                {...option.textField}
                                                                                values={values}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                        />
                                                                        <ErrorCommon errors={errors} name={field.name}
                                                                                     touched={touched} />
                                                                    {/*</Grid>*/}
                                                                </Grid>
                                                            </Grid>
                                                    }
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    {(option.value === "PR" || option.value === "VISA_PLAN") && (
                                                            <GreenCardAndVisaExpiry type={option.value} required={false} />
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                ))}
                            </Grid>
                        </RadioGroup>
                    </Grid>
            );
        })
        }
    </>;

}

interface DocumentFieldsProps {

}


const DocumentFields = (props:DocumentFieldsProps) =>{
    const {
        values, setFieldValue, errors, handleChange, touched
    } = useFormikContext<any>()
    const [disabled, setDisabled] = React.useState(true);
    const isAllianz = isAllianzApp(values.offerType)
    const fields:any = [
        {
            name: "proofExpiryMonth",
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            isRequired: false,
            filedType: "selectbox",
            disabled: disabled,
            label: <Label label={"Month"} required={false}/>,
            options: getMonths(),
            // onSelectChange: (val: number) => {
            // },
            getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                if (val && formValues["proofExpiryYear"]) {
                    // const endOfMonth = moment(formValues["proofExpiryYear"] + "-" + val).endOf("month").format("D");
                    // const date = new Date(formValues["proofExpiryYear"] + "-" + val + "-" + endOfMonth);
                    // const result = checkProofExpiry(date);
                    // setProofExpired(result);
                }
            },
        }, {
            name: "proofExpiryYear",
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            isRequired: false,
            disabled: disabled,
            label: <Label label={"Year"} required={false}/>,
            options: getNextYears(),
            // onSelectChange: (val: number) => {
            // },
            getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                if (val && formValues["proofExpiryMonth"]) {
                    // const endOfMonth = moment(val + "-" + formValues["proofExpiryMonth"]).endOf("month").format("D");
                    // const date = new Date(val + "-" + formValues["proofExpiryMonth"] + "-" + endOfMonth);
                    // const result = checkProofExpiry(date);
                    // setProofExpired(result);
                }
            },
        },

    ];

    if(isAllianz){
        fields.push( {
            id: "employeeIdState",
            name: "employeeIdState",
            label: <Label label={"DL State"} required={false} />,
            isRequired: false,
            placeholder: "Search State",
            cb: (value) => {
            },
            component: AutoComplete,
            className: "SelectFieldWidth",
            variant: "outlined",
            contentList: stateDropDownArr,
            onSelectChange: (val: string) => {
                // if (typeof setEmployeeIdStateValue === "function") {
                //     setEmployeeIdStateValue(val);
                // }
            },
            disabled: disabled,
            browserSuggestions: false,
        },)
    }else {
        fields.push({
            name: "employeeIdState",
            label: <Label label={"State"} required={false}/>,
            isRequired: false,
            component: TextField,
            className: "TextFieldWidth",
            variant: "outlined",
            disabled: disabled,
            options: stateDropDownArr,
            // onSelectChange: (val: number) => {
            // },
        })
    }

    const identityIdField =  {
        name: "employeeIdNumber",
        helperFieldText: "Must be a valid drivers license",
        label: <Label label={`Enter ${values["identityType"] === "drivingLicence" ? "drivers license" : "passport"} number`} required={false}/>,
        isRequired: false,
        className: "mt35 TextFieldWidth",
        filedType: "string",
        disabled: disabled,
        component: TextField,
        variant: "outlined",
    };



    return <>
        <Grid item xs={12} md={12} xl={12}>
            <Typography variant="caption" className="floatLeft">
                <strong>Verification Details</strong>
            </Typography>
            <Button color="primary"
                    onClick={()=>{
                        setDisabled(!disabled);
                    }}
                    className="floatRight mt15Small"
                    style={{ lineHeight: "27px" }}>
                <EditIcon/> Edit Verification Information
            </Button>
        </Grid>
        <Grid item xs={12} md={12} xl={12}>
            <Typography variant="caption" className="floatLeft">
                <Label label={"How would you like to verify your identity?"}
                       required={false}/>
            </Typography>

            <ToggleButtonGroup
                    color={"primary"}
                    className="toggleButtonGroup"
                    size="large"
                    exclusive
                    id={"identityType"}
                    value={values["identityType"]}
                    onChange={(e: any, val: string) => {
                        setFieldValue("identityType", val);
                        setFieldValue("employeeIdNumber", "");
                        setFieldValue("employeeIdState", "");
                        setFieldValue("proofExpiryYear", 0);
                        setFieldValue("proofExpiryMonth", 0);
                        // setProofExpired(false);
                    }}
            >
                <ToggleButton value={"drivingLicence"}
                              disabled={disabled}
                              className={values["identityType"] === "drivingLicence" ? "active" : ""}>
                    US DRIVER'S LICENSE
                </ToggleButton>
                <ToggleButton value={"passport"}
                              disabled={disabled}
                              className={values["identityType"] === "drivingLicence" ? "" : "active"}>
                    US PASSPORT
                </ToggleButton>
            </ToggleButtonGroup>
        </Grid>
        <Grid
                item xs={12} md={6} lg={6} xl={4}  className="mb15"
        >
            <TextFieldCommon
                    {...identityIdField} values={values} onChange={handleChange}
            />
            <ErrorCommon
                    errors={errors} name={identityIdField.name} touched={touched}
            />

        </Grid>
        <Grid item xs={12}  id="proofExpireRef">
            <Typography variant="caption" className="floatRight-">
                Expiry Date (must
                match {values["identityType"] === "drivingLicence" ? "drivers license" : "passport"})
            </Typography>
        </Grid>
        {fields.map((field, index) => {
            return (
                    <Grid
                            item xs={12} md={6} lg={6} xl={4} key={index} className="mb15"
                    >
                        <TextFieldCommon
                                {...field} values={values} onChange={handleChange}
                        />
                        <ErrorCommon
                                errors={errors} name={field.name} touched={touched}
                        />

                    </Grid>
            );
        })
        }

    </>

}